import * as React from 'react';
import { Layout } from './components/Layout';
import { FromPackageContainer } from './components/FromPackage';
import { PackagesContainer } from './components/Packages';
import { SinglePackageContainer } from './components/SinglePackage';
import { PublicationPriceContainer } from './components/PublicationPrice';
import { RecommendedPackagesContainer } from './components/RecommendedPackages';
import { RecommendedPackagesPaymentStatusContainer } from './components/RecommendedPackagesPaymentStatus';
import { useSelector } from 'react-redux';
import {
  selectIsPackagesAvailable,
  selectIsPackagesVisible,
  selectIsSinglePackage,
} from '../../../../selectors/publishTerms';
import { selectIsRecommendedPackagesAvailable } from '../../../../selectors/recommendedPackages';

export const PublicationSectionContainer = () => {
  const isSinglePackage = useSelector(selectIsSinglePackage);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const isPackagesVisible = useSelector(selectIsPackagesVisible);
  const isRecommendedPackagesAvailable = useSelector(selectIsRecommendedPackagesAvailable);

  return (
    <Layout
      price={!isRecommendedPackagesAvailable && <PublicationPriceContainer />}
      fromPackage={!isSinglePackage && isPackagesAvailable && <FromPackageContainer />}
      packages={!isSinglePackage && isPackagesVisible && <PackagesContainer />}
      singlePackage={isSinglePackage && <SinglePackageContainer />}
      // пока идёт A/B тестирование, рекомендованные пакеты доступны только для десктопа
      // @TODO убрать проверку девайса после обкатки
      recommendedPackages={<RecommendedPackagesContainer />}
      recommendedPackagesPaymentStatus={<RecommendedPackagesPaymentStatusContainer />}
    />
  );
};
